import { render, staticRenderFns } from "./ContractorCategoryForm.vue?vue&type=template&id=0bbc6732&"
import script from "./ContractorCategoryForm.vue?vue&type=script&lang=js&"
export * from "./ContractorCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports